import React from 'react';
import MetricCard from './ui/MetricCard';
import { formatMoney, formatKg, formatDistance } from '../shared/formatters';

interface JourneyTotalsCardsProps {
  totalCost: number;
  totalCo2: number;
  totalDistance: number;
  className?: string;
}

/**
 * Displays the high-level journey totals (cost, emissions, distance) using
 * the same visual treatment the old inline cards had (tinted backgrounds,
 * specific icons, and label copy).
 */
const JourneyTotalsCards: React.FC<JourneyTotalsCardsProps> = ({
  totalCost,
  totalCo2,
  totalDistance,
  className = '',
}) => {
  const sharedLabelClasses = 'text-[var(--text)] font-semibold text-base';
  const sharedValueClasses = 'text-[var(--text)] font-semibold text-base';

  const cards = [
    {
      label: 'Total Distance',
      icon: '📏',
      value: formatDistance(totalDistance),
      backgroundColor: '#fef3c7',
    },
    {
      label: 'Transport Emissions',
      icon: '🌱',
      value: `${formatKg(totalCo2)} CO2e`,
      backgroundColor: '#dcfce7',
    },
    {
      label: 'Transport Costs',
      icon: '💸',
      value: formatMoney(totalCost),
      backgroundColor: '#dbeafe',
    },
  ];

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-3 gap-4 ${className}`}>
      {cards.map((card) => (
        <MetricCard
          key={card.label}
          {...card}
          fontSize="text-base"
          labelClassName={sharedLabelClasses}
          valueClassName={sharedValueClasses}
          inlineOnMobile
        />
      ))}
    </div>
  );
};

export default JourneyTotalsCards;

